import React, { useEffect, useState, useCallback } from "react";
import "./style.scss";
import { message, Modal, Pagination, Table } from "antd";
import { Link } from "react-router-dom";
import {
  useDownloadDeliverable,
  useGetAllBatchesForReview,
} from "../../../hooks/useReview";
import Button from "../../../common/Button";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import useAuthContext from "../../../hooks/useAuthContext";

const Download = () => {
  const {
    user: { userEmail },
  } = useAuthContext();
  const [batchList, setBatchList] = useState([]);
  const [pagination, setPagination] = useState({ pageSize: 15, pageNum: 1 });
  const [totalCount, setTotalCount] = useState(0);
  const [downloadModalVisible, setDownloadModalVisible] = useState(false);
  const [emails, setEmails] = useState([userEmail]);
  const [selectedBatchId, setSelectedBatchId] = useState("");

  const { pageNum, pageSize } = pagination;

  const onPageChange = (page, size) => {
    setPagination((prev) => ({
      pageNum: page !== prev.pageNum ? page : 1,
      pageSize: size,
    }));
  };

  const onSuccessGetAllBatches = (res) => {
    if (res.status === 200) {
      setBatchList(res.data.data);
      setTotalCount(res.data.totalCount);
    }
  };

  const { data: getAllBatches } = useGetAllBatchesForReview(
    "batch_list",
    pageNum,
    pageSize,
    onSuccessGetAllBatches,
    (err) => console.error(err)
  );

  const onSuccessDownload = (res) => {
    if (res.status === 200) {
      message.success(
        "Your download request has been received. An email with the download link will be sent to you shortly."
      );
      setDownloadModalVisible(false);
    }
  };

  const { mutate: downloadBatchFile } = useDownloadDeliverable(
    onSuccessDownload,
    () => message.error("Download failed, please try again.")
  );

  const downloadBatch = useCallback(() => {
    downloadBatchFile({ batchId: selectedBatchId, toEmailIds: emails });
  }, [selectedBatchId, emails, downloadBatchFile]);

  const renderDownloadModal = () => (
    <Modal
      title="Download"
      visible={downloadModalVisible}
      onCancel={() => setDownloadModalVisible(false)}
      className="download_modal_wrapper"
      footer={null}
      width="70%"
    >
      <div className="download_modal_container">
        <div className="download_form_wrapper">
          <ReactMultiEmail
            placeholder="Input your Email Address"
            emails={emails}
            onChange={setEmails}
            getLabel={(email, index, removeEmail) => (
              <div data-tag key={index}>
                {email}
                {index > 0 && (
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                )}
              </div>
            )}
          />
        </div>
        <div className="action_wrapper">
          <button
            className="cancelBtn"
            onClick={() => setDownloadModalVisible(false)}
          >
            Cancel
          </button>
          <Button
            width="140px"
            height="50px"
            text="Download"
            handleClick={downloadBatch}
          />
        </div>
      </div>
    </Modal>
  );

  const columns = [
    {
      title: "Batch Name",
      key: "name",
      align: "center",
      dataIndex: "name",
      render: (name, record) => (
        <div>{`${record.name || ""} ${record.lastName || ""}`}</div>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => (
        <Link
          onClick={() => {
            setDownloadModalVisible(true);
            setSelectedBatchId(record._id);
          }}
        >
          Download
        </Link>
      ),
    },
  ];

  return (
    <div className="download_batch_list">
      <div className="download_batch_list_content">
        <div className="list_wrapper">
          <Table
            columns={columns}
            dataSource={batchList}
            pagination={false}
            scroll={{ y: "100%" }}
            className="main_table"
          />
        </div>
        <div className="pagination_wrapper">
          <Pagination
            total={totalCount}
            current={pageNum}
            pageSize={pageSize}
            onChange={onPageChange}
          />
        </div>
      </div>
      {downloadModalVisible && renderDownloadModal()}
    </div>
  );
};

export default Download;
